import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Container,
  Row,
} from "reactstrap";
// core components
import Users from "components/Tables/User.js";
import UserModal from "components/Modals/User.js";
import Header from "components/Headers/UserHeader";
import UserDataService from "../../services/UserDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      users: [],
      warehouses: [],
      perPage: 10,
      currentPage: 1,
      currentUser: {},
    };
    this.UserDataService = new UserDataService();
    this.warehouseDataService = new WarehouseDataService();
  }

  getWarehouses() {
    this.warehouseDataService.getList(1, 99999, null)
      .then((data) => {
        return {
          warehouses: data.data.warehouse_list !== null && data.data.errorMessage === undefined ? data.data.warehouse_list : [],
        };
      })
      .then((res) => this.setState({ warehouses: res.warehouses }));
    setTimeout(() => {
      this.setState({ errorMessage: undefined });
    }, 5000);
  }  
  
  toggleModal = (state, formType, user) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentUser: user,
    });
  };

  componentDidMount() {
    this.fetchData()
    this.getWarehouses()
  }
  
  handleSearch = (e) => {
    const keyword = e.target.value;
    this.setState({ 
      currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
      keyword: keyword,
    }, () => {
      this.fetchData(keyword);
    });
  }
  
  fetchData(keyword) {
    this.UserDataService
      .getList(keyword, this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
  }

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
        currentPage: selectedPage,
    }, () => {
      this.fetchData(this.state.keyword)
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message})
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const renderPageNumbers = pageNumbers.map(number => {
      return (
        <PaginationItem className={this.state.currentPage === number ? "active" : ""}>
          <PaginationLink
            onClick={() => this.handlePageClick(number)}
          >
            {number} 
          </PaginationLink>
        </PaginationItem> 
      )
    })
    
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar user</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        onClick={() => this.toggleModal("formModal", "add")}
                        size="sm"
                      >
                        Tambah baru
                      </Button>
                      <UserModal
                        toggleModal={() => this.toggleModal("formModal")}
                        formModal={this.state.formModal}
                        formType={this.state.formType}
                        currentUser={this.state.currentUser}
                        warehouses={this.state.warehouses}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                      />
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs="4" className="mt-3 align-items-right">
                      <FormGroup>
                        <InputGroup className="input-group-alternative mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-zoom-split-in" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            className="form-control-alternative"
                            placeholder="Search"
                            onChange={(e) => this.handleSearch(e)}
                            type="text"
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <Users 
                  users={this.state.users} 
                  warehouses={this.state.warehouses}
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  fetchData={this.fetchData.bind(this)}
                />
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handlePreviousPageClick()}
                          tabIndex="-1"
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Previous</span>
                        </PaginationLink>
                      </PaginationItem>
                      {renderPageNumbers}
                      <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                        <PaginationLink
                          onClick={() => this.handleNextPageClick()}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
